const failedVerifications = ["Verification Failed", "Unable To Verify", "Max Attempts Reached"];

export function getVerificationResult(verificationResult) {
    if (verificationResult == null) {
        return "";
    }

    if (failedVerifications.includes(verificationResult.result)) {
        return "Verification Failed";
    } else if (verificationResult.source === "Manual") {
        return "Manually Verified";
    } else {
        return "Verified";
    }
}
